import MetaConfList from './MetaConfList'

MetaConfList.install = function (Vue) {
    Vue.component(MetaConfList.name, MetaConfList);
}

export default MetaConfList;